import tripStatuses from '../../trip-statuses';
import suppliers from './../../../../modules/supplier/suppliers';


export default function TripCheckoutHotelController(
    tripDetails,
    moment,
    REFUNDABLE_TYPES,
) {
    'ngInject';
        const vm = this;
        const readOnlyStatuses = [tripStatuses.CANCELLED, tripStatuses.CONFIRMED];

        Object.assign(vm, {
            isMessageBoxVisible,
            isMessageToHotelReadOnly,
            moment,
            REFUNDABLE_TYPES,
        });

        function isMessageToHotelReadOnly() {
            return readOnlyStatuses.includes(tripDetails.Status)
                || tripDetails.IsOfflineTrip;
        }

        function isMessageBoxVisible(hotel) {
            return hotel && hotel.Supplier === suppliers.amadeus.id
                || (hotel && hotel.Supplier === suppliers.bookingCom.id);
        }
}



// WEBPACK FOOTER //
// ./src/app/modules/trip/controllers/checkout/trip-checkout-hotel-controller.js